import { jsx as _jsx } from "react/jsx-runtime";
import { Breadcrumb as BaseBreadcrumb, Text } from "native-base";
import { useLinking } from "../providers/routing";
const BreadcrumbLink = ({ route, params, children, }) => {
    const linkProps = useLinking(route, params);
    return (_jsx(BaseBreadcrumb.Link, Object.assign({ _text: {
            style: {
                fontWeight: "500",
            },
            textDecoration: "none",
            color: "gray.700",
        }, _hover: {
            _text: {
                color: "gray.800",
            },
        } }, { children: _jsx(Text, Object.assign({}, linkProps, { children: children })) })));
};
export default BreadcrumbLink;
